const SERVICE_ITEMS = ["BRANDING", "LOGO DESIGN", "SOCIAL MEDIA", "WEBSITES", "SHOPIFY", "PACKAGING", "UI/UX", "PUBLICATION", "SHOOTS", "AI VIDEO", "STORYTELLING"];

function Row({ items, cls }) {
  return (
    <span className="inline-flex items-center">
      {items.map((it, i) => (
        <span key={it + i} className={`${cls} pr-[120px]`}>{it}</span>
      ))}
    </span>
  );
}

export default function ServicesMarquee({ items = SERVICE_ITEMS, duration = 40, testid = "services-marquee", size = "text-[15px]" }) {
  const cls = `font-mono uppercase ${size} tracking-[0.08em] text-black`;
  return (
    <div className="w-full overflow-hidden py-2" data-testid={testid}>
      <div className="qissa-marquee" style={{ animationDuration: `${duration}s` }}>
        <Row items={items} cls={cls} />
        <Row items={items} cls={cls} />
      </div>
    </div>
  );
}
